import { router } from "expo-router"

/**
 * Go back one step in the stack, or to root if there is no history.
 * Use for overlay screens (e.g. menu) where "close" should return to the
 * previous screen (e.g. video player) when the user navigated there, and
 * only go to root when the user landed directly (e.g. after a reload).
 */
export function backOrToRoot(): void {
  if (router.canDismiss()) {
    router.back()
  } else {
    router.replace("/")
  }
}

/**
 * Navigate back to the root (index) screen. Use for close/dismiss actions
 * on full-screen flows (video player, browser, etc.) where closing should
 * always land on the main chat.
 *
 * On web, if the user landed directly on the current route (e.g. after a full
 * page reload), there is no in-app history, so router.back() does nothing.
 * This helper uses replace("/") in that case so the close button still takes
 * the user to the root screen.
 */
export function backToRoot(): void {
  if (router.canDismiss()) {
    router.dismissTo("/")
  } else {
    router.replace("/")
  }
}
